module.exports = __webpack_public_path__ + "img/sent.4d1249d.svg";